import styled from 'styled-components';

export const Content = styled.div`
  padding: 16px;
  box-sizing: border-box;
  color: #e6eaec;
  textarea {
    box-sizing: border-box;
    font-size: 14px;
    color: #e6eaec;
    background-color: #10151a;
    border: 1px solid #3d4952;
    overflow: hidden;
    padding: 10px 12px;
    border-radius: 10px;
    resize: none;
    outline: none;
    transition: border-color 0.15s ease-in, box-shadow 0.15s ease-in;
  }
  textarea:focus {
    border-color: #47b972;
    box-shadow: 0 0 0 3px rgba(71, 185, 114, 0.22);
  }
  select {
    box-sizing: border-box;
    width: 100%;
    height: 38px;
    padding: 0 34px 0 12px;
    font-family: inherit;
    font-size: 14px;
    color: #e6eaec;
    background-color: #1a2429;
    border: 1px solid #3d4952;
    border-radius: 10px;
    outline: none;
    cursor: pointer;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath d='M2 4l4 4 4-4' stroke='%23aab2b8' stroke-width='1.6' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 12px center;
    transition: border-color 0.15s ease-in, box-shadow 0.15s ease-in;
  }
  select option {
    background-color: #1a2429;
    color: #e6eaec;
  }
  select:focus {
    border-color: #47b972;
    box-shadow: 0 0 0 3px rgba(71, 185, 114, 0.22);
  }
`;
export const Label = styled.label`
  color: #aab2b8;
  display: block;
  margin: 0 0 7px;
  font-size: 13px;
  font-weight: 500;
`;
export const TypeSelector = styled.div`
  margin: 0 0 16px;
`;

export const Buttons = styled.div`
  justify-content: space-between;
  display: flex;
  gap: 12px;
`;
export const Button = styled.button`
  box-sizing: border-box;
  height: 38px;
  line-height: normal;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  color: #e6eaec;
  border-radius: 10px;
  padding: 0 18px;
  border: 1px solid #3d4952;
  cursor: pointer;
  background: #1a2429;
  margin: 0;
  position: relative;
  transition: background 0.15s ease-in, border-color 0.15s ease-in, color 0.15s ease-in;
  &:hover {
    background: #232e35;
    border-color: #47b972;
    color: #ffffff;
  }
  &:active {
    background: #17201d;
    border-color: #3aa863;
  }
`;
